// extracted by mini-css-extract-plugin
export var layoutContainer = "_as-0";
export var layoutContainerNoRounding = "_as-6";
export var layoutContainerOpen = "_as-5";
export var layoutContainerResizing = "_as-1";
export var mainContent = "_as-2";
export var resizeDivider = "_as-3";
export var slidePanel = "_as-4";